import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeCareerSkeleton } from './TypeCareer';
import type { TypeIconSkeleton } from './TypeIcon';

export interface TypeBlockJobListFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Symbol;
    careers?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeCareerSkeleton>>;
    extraJobHeader?: EntryFieldTypes.Symbol;
    extraJobBody?: EntryFieldTypes.Text;
    extraJobIcon?: EntryFieldTypes.EntryLink<TypeIconSkeleton>;
}

export type TypeBlockJobListSkeleton = EntrySkeletonType<TypeBlockJobListFields, 'blockJobList'>;
export type TypeBlockJobList<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockJobListSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockJobList<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockJobList<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockJobList';
}
